module.exports = __webpack_public_path__ + "static/media/lr.8483351a.svg";